<template>
  <div>
    <v-container
      fluid
      class="mx-12 my-6 d-flex flex-column justify-start main-container"
    >
      <div class="card-label d-flex flex-row mb-4">
        <v-icon>mdi-bell-outline</v-icon>
        <p class="mb-0 ml-4 subtitle-1 font-weight-bold">
          Custom Notifications
        </p>
      </div>
      <div v-if="access.read">
        <div v-if="!loading" class="d-flex flex-row flex-wrap">
          <v-card
            v-for="(n, index) in notifications"
            :key="index"
            class="mx-4 mb-6 pa-4"
            width="300"
            min-height="250"
            elevation="0"
            @click="openUpdate(n)"
          >
            <v-card-text>
              <div class="d-flex flex-row justify-space-between">
                <p class="headline">
                  {{ n.title }}
                </p>
                <v-icon right :color="n.inactive ? 'gray' : 'green'"
                  >mdi-circle-medium</v-icon
                >
              </div>
              <p class="caption mb-2">
                {{ parseType(n.type) }}
              </p>

              <div v-for="(ns, i) in n.frequency" :key="i" class="px-0">
                <div class="d-flex flex-row">
                  <v-icon class="mr-2" color="indigo" small
                    >mdi-bell-ring-outline</v-icon
                  >

                  <p v-if="ns.duration > 0">
                    {{ ns.duration }} {{ ns.unit
                    }}{{ ns.duration > 1 ? 's' : '' }} after
                  </p>
                  <p v-else>
                    {{ Math.abs(ns.duration) }} {{ ns.unit
                    }}{{ Math.abs(ns.duration) > 1 ? 's' : '' }} before
                  </p>
                </div>
              </div>

              <v-divider class="my-2"></v-divider>

              <v-chip-group column>
                <v-chip
                  v-for="category in n.categories"
                  :key="category"
                  x-small
                  >{{ parseCategory(category) }}</v-chip
                >
              </v-chip-group>
            </v-card-text>
          </v-card>

          <v-card
            v-if="notifications.length < maxNotifications && access.create"
            class="mx-4 mb-6 pa-4 d-flex align-center"
            style="justify-content: center"
            width="300"
            min-height="250"
            elevation="0"
            @click="openCreate"
          >
            <v-icon size="50">mdi-plus-circle-outline</v-icon>
          </v-card>
          <v-card
            v-else-if="!access.create"
            class="mx-4 mb-6 pa-4 d-flex align-center"
            style="justify-content: center; background-color: lightgrey"
            width="300"
            min-height="250"
            elevation="0"
          >
            <p class="caption text-center">
              You are not authorized to create custom notifications.
            </p>
          </v-card>
          <v-card
            v-else
            class="mx-4 mb-6 pa-4 d-flex align-center"
            style="justify-content: center; background-color: lightgrey"
            width="300"
            min-height="250"
            elevation="0"
          >
            <p class="caption text-center">
              You have reached the maximum number of custom notifications you
              can create for this property.
            </p>
          </v-card>
        </div>
        <v-skeleton-loader
          v-else
          ref="skeleton"
          type="card"
          loading
          class="mx-auto"
          max-width="300"
        ></v-skeleton-loader>
      </div>
    </v-container>
    <CreateCustomNotification
      ref="createCustomNotification"
    ></CreateCustomNotification>
    <UpdateCustomNotification
      ref="updateCustomNotification"
    ></UpdateCustomNotification>
    <v-dialog
      v-model="details"
      max-width="500"
      :style="{ zIndex: 200 }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-container class="px-10 py-8">
          <p class="subtitle-1 font-weight-bold mb-0">Notification Details</p>
          <v-divider class="my-4"></v-divider>
          <p class="caption font-weight-bold my-2">Email Message:</p>
          <p class="caption" v-html="emailMessage"></p>
          <v-divider class="my-4"></v-divider>
          <p class="caption font-weight-bold my-2">SMS Message:</p>
          <p class="caption" v-html="smsMessage"></p>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CreateCustomNotification from '../components/custom/CreateCustomNotification.vue'
import UpdateCustomNotification from '../components/custom/UpdateCustomNotification.vue'

export default {
  components: {
    CreateCustomNotification,
    UpdateCustomNotification
  },
  data() {
    return {
      loading: true,
      emailMessage: '',
      smsMessage: '',
      details: false
    }
  },
  computed: {
    notifications() {
      return this.$store.getters['notifications/getNotifications']
    },
    access() {
      return this.$root.$roleAccess('custom_notifications').access
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    paymentCategories() {
      return this.property.payment_categories_details[0].categories
    },
    maxNotifications() {
      return 5
    }
  },
  async mounted() {
    await this.$store.dispatch('notifications/fetchNotificationsAction')
    this.loading = false
  },
  methods: {
    parseCategory(category) {
      const paymentCategory = this.paymentCategories.find(
        (paymentCategory) => paymentCategory.value === category
      )

      return paymentCategory.text
    },
    parseType(type) {
      switch (type) {
        case 'MOVE_IN_DATE':
          return 'Move in date'
        case 'MOVE_OUT_DATE':
          return 'Move out date'
        case 'DUE_DATE':
        default:
          return 'Payment due date'
      }
    },
    openDetails(n) {
      this.emailMessage = n.emailMessage
      this.smsMessage = n.smsMessage
      this.details = true
    },
    openCreate() {
      this.$refs.createCustomNotification.open()
    },
    openUpdate(n) {
      this.$refs.updateCustomNotification.open(n)
    }
  }
}
</script>

<style scoped>
.main-container {
  min-height: 100vh;
}
.v-card {
  border-radius: 12px !important;
}
.v-input {
  border-radius: 10px;
}
.v-btn {
  border-radius: 20px;
}
table tbody tr td {
  border: none !important;
  border-bottom: none !important;
}
p {
  margin-bottom: 0;
}
</style>
